import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';


@Injectable()
export class EmailService {
  private url = 'https://formspree.io/jeremydelacasa2@gmail.com'
  constructor(private http: Http){}

  send(data) {
    return this.http.post(this.url, data)
    .toPromise()
    .then(response => {
        return response.json();
    })
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/home/email.service.ts